// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-table[data-v-0cd3d506]{border:1px solid #dddbda;border-radius:5px}", ""]);
// Exports
module.exports = exports;
